<template>
  <v-dialog
    v-model="dialog"
    class="ma-auto wrapper-2 bg-white w-350"
    width="fit-content"
    :class="[language === 'he' ? 'dir-rtl' : 'dir-ltr']"
  >
  <v-card>

    <v-card-title class="bg-grey mb-2 fs-1-5r">
      <span> {{ $t('Success') }}</span>
    </v-card-title>
    <div class="pa-4">
      <span class="font-size-16">{{ computedMessage }}</span>
    </div>
    <v-divider></v-divider>
    <div class="d-flex justify-end pa-4">
      <Button
      width="110"
      :clickAction="continueSession"
      :text="$t('Continue')"
      />
    </div>
  </v-card>
  </v-dialog>
</template>

<script>
import { mapActions ,mapGetters } from 'vuex'

//Base components
import Button from '@/components/BaseComponents/Button/Button.vue'

export default {
  name: 'ContinueScreen',
  data() {
    return {
      dialog: true,
    }
  },
  props: { email: String, isFirstTimeGlobal: Boolean },
  components: { Button },
  computed: {
    ...mapGetters(['language']),
    computedMessage() {
      if (this.isFirstTimeGlobal)
        return this.$t('Your password was successfully created')
      return this.$t('Your password was successfully updated')
    },
  },
  methods: {
    ...mapActions(['LOG_OUT']),
    async continueSession() {
      await this.LOG_OUT()
      this.$router.push({ name: 'Home', query: { email: this.email } })
    },
  },
}
</script>
